import { render, staticRenderFns } from "./NomeGrupo.vue?vue&type=template&id=287ac898"
import script from "./NomeGrupo.vue?vue&type=script&lang=js"
export * from "./NomeGrupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports